import { Heading, BodyText } from "@/components/design-system/Typography";
import { Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import HomeHeader from "@/components/home/HomeHeader";
import HomeFooter from "@/components/home/HomeFooter";

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F4F6F8] to-white">
      <HomeHeader />
      
      <section className="container mx-auto px-4 py-16">
        <div className="max-w-2xl mx-auto text-center space-y-8">
          <Heading level={1}>Kontakta oss</Heading>
          
          <div className="space-y-6">
            <BodyText size="lg" className="text-[#1B365D]">
              Frank är en AI-assistent som hjälper bostadsrättsföreningar att automatisera vanliga frågor från medlemmar och förenkla administrationen.
            </BodyText>
            
            <BodyText size="lg" className="text-[#1B365D]">
              Med Frank kan medlemmar få svar på sina frågor dygnet runt, medan styrelsen sparar tid och kan fokusera på viktiga beslut.
            </BodyText>
          </div>

          <div className="bg-white p-8 rounded-lg border border-[#E6EEF5] shadow-sm">
            <div className="flex items-center justify-center space-x-4">
              <div className="w-12 h-12 bg-[#F4F6F8] rounded-full flex items-center justify-center">
                <Mail className="h-6 w-6 text-[#2F80ED]" />
              </div>
              <div className="text-center">
                <Heading level={3} className="mb-1">Kontakta oss</Heading>
                <BodyText className="font-semibold text-[#1A237E]">info@fragafrank.se</BodyText>
                <BodyText color="muted" size="sm">Vi svarar inom 24 timmar</BodyText>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeFooter />
    </div>
  );
};

export default ContactPage;